import {createAction} from "redux-act";

export const subscribeToLiveScores = createAction<number>();
export const unsubscribeFromLiveScores = createAction();
